/* eslint-disable react/no-danger */
/* eslint-disable react/no-unstable-nested-components */

import cn from 'classnames';
import he from 'he';
import { useContext } from 'react';

import { ModalContext } from '@shared/libs';
import type { Locale } from '@shared/libs';
import { unbounded, Button } from '@shared/ui';

import { Modal } from './modal';
import styles from './video-lesson.module.css';

type TProps = {
  locale: Locale;
  title: string;
};

export const VideoLesson = ({ locale, title }: TProps) => {
  const openModal = useContext(ModalContext);

  const handleClick = () => {
    openModal({
      modal: {
        title: he.decode(locale.NOTE_VIDEO_LESSON_FORM_TITLE || 'NOTE_VIDEO_LESSON_FORM_TITLE'),
        Content: (props) => <Modal title={title} locale={locale} {...props} />,
      },
    });
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.anchor} id="video-lessons" />
      <div className={styles.block}>
        <div className={styles.main}>
          <span className={cn(unbounded.className, styles.title)}>
            {he.decode(locale.NOTE_VIDEO_LESSON_TITLE || 'NOTE_VIDEO_LESSON_TITLE')}
          </span>
          <span className={styles.text}>
            {he.decode(locale.NOTE_VIDEO_LESSON_TEXT_1 || 'NOTE_VIDEO_LESSON_TEXT_1')} {title}{' '}
            {he.decode(locale.NOTE_VIDEO_LESSON_TEXT_2 || 'NOTE_VIDEO_LESSON_TEXT_2')}
          </span>
        </div>
        <div className={styles.actionBlock}>
          <div className={styles.action}>
            <span
              className={styles.dscr}
              dangerouslySetInnerHTML={{
                __html: he.decode(locale.NOTE_VIDEO_LESSON_DSCR || 'NOTE_VIDEO_LESSON_DSCR'),
              }}
            />
            <Button className={styles.btn} onClick={handleClick} color="green">
              {he.decode(locale.NOTE_VIDEO_LESSON_BTN || 'NOTE_VIDEO_LESSON_BTN')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
